import React from 'react';
import type { SanitySupportArticleReusableBlock } from '@repo/models/gatsby-graphql-types';
import SupportArticleSectionTypes from './index';

interface SupportArticleReusableBlockProps {
  section?: SanitySupportArticleReusableBlock;
}

function SupportArticleReusableBlock({
  section,
}: Readonly<SupportArticleReusableBlockProps>) {
  return (
    <>
      {section.blockReference?.blocks?.map(section => {
        if (SupportArticleSectionTypes.hasOwnProperty(section._type)) {
          return React.createElement(
            SupportArticleSectionTypes[section._type],
            { section: section, key: section._key }
          );
        }
      })}
    </>
  );
}

export default SupportArticleReusableBlock;
